export default __webpack_public_path__ + "static/media/education_savings_account_light.de24242d.png";